// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WasmMsg_wrapper__BOup_"};